/* JAEL Café · Sincroniza la barra móvil con la variante nativa. */
(() => {
  'use strict';

  function init() {
    const bar = document.querySelector('[data-jael-mobile-buy]');
    if (!bar || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS !== 'object') return;

    const sectionId = bar.dataset.sectionId;
    const price = bar.querySelector('[data-jael-mobile-price]');
    const button = bar.querySelector('button[form]');

    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (!data || data.sectionId !== sectionId || !data.html) return;

      const nextPrice = data.html
        .getElementById(`price-${sectionId}`)
        ?.querySelector('.price-item--regular, .price-item--sale');

      if (price && nextPrice) price.textContent = nextPrice.textContent.trim();
      if (button && data.variant) button.disabled = data.variant.available === false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
